var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-contanier" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "tab" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "QT",
                  expression: "'QT'",
                },
              ],
              staticClass: "tabItem",
              class: { active: _vm.active === 0 },
              on: {
                click: function ($event) {
                  return _vm.changeType(0, "QT")
                },
              },
            },
            [_vm._v("清提")]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "QTYW",
                  expression: "'QTYW'",
                },
              ],
              staticClass: "tabItem",
              class: { active: _vm.active === 1 },
              on: {
                click: function ($event) {
                  return _vm.changeType(1, "QTYW")
                },
              },
            },
            [_vm._v("其他业务")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "opt" },
          [
            _vm.filterList.date && _vm.isActive
              ? _c("div", { staticClass: "checkDate flex_c_c" }, [
                  _vm._v(
                    " 查询时间：" +
                      _vm._s(
                        _vm.filterList.date[0] + "~" + _vm.filterList.date[1]
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "search" },
              [
                _c(
                  "el-popover",
                  {
                    ref: "popover",
                    staticClass: "searchPop",
                    attrs: {
                      placement: "top",
                      title: "批量搜索",
                      trigger: "click",
                      width: "378",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "close-pop",
                        on: { click: _vm.closeSearchPanel },
                      },
                      [_c("i", { staticClass: "el-icon-close" })]
                    ),
                    _c("base-muti-input", {
                      ref: "baseMutiInput",
                      model: {
                        value: _vm.referenceNumber,
                        callback: function ($$v) {
                          _vm.referenceNumber = $$v
                        },
                        expression: "referenceNumber",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "right",
                          margin: "16px 0 0",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.handleEmpty },
                          },
                          [_vm._v("清空")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "sure",
                            on: { mousedown: _vm.handleConfirm },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-input", {
                  staticClass: "input-search",
                  attrs: {
                    value: _vm.searchVal,
                    placeholder: "请输入提单号搜索",
                  },
                  on: { focus: _vm.handleFocus },
                }),
                _c(
                  "div",
                  {
                    staticClass: "btn-search",
                    on: { click: _vm.handleConfirm },
                  },
                  [_c("i", { staticClass: "el-icon-search" })]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.computedPermissions("导出"),
                    expression: "computedPermissions('导出')",
                  },
                ],
                staticClass: "upload flex_c_c",
                attrs: { "v-permissson": _vm.computedPermissions("导出") },
                on: {
                  click: function ($event) {
                    return _vm.exportListFile()
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/const/derive.png"),
                    alt: "",
                  },
                }),
                _vm._v(" 导出 "),
              ]
            ),
            _c(
              "el-tooltip",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.computedPermissions("关账"),
                    expression: "computedPermissions('关账')",
                  },
                ],
                staticClass: "item",
                attrs: {
                  "v-permissson": _vm.computedPermissions("关账"),
                  effect: "dark",
                  content: "只能关闭已核销的数据!",
                  placement: "right",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "close flex_c_c",
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible2 = true
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/const/closeBill.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" 关账 "),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active === 1,
                    expression: "active === 1",
                  },
                  {
                    name: "permissson",
                    rawName: "v-permissson",
                    value: "closeMoney",
                    expression: "'closeMoney'",
                  },
                ],
                staticClass: "close flex_c_c",
                on: {
                  click: function ($event) {
                    _vm.dialogVisible5 = true
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/const/closeMoney.png"),
                    alt: "",
                  },
                }),
                _vm._v(" 结账 "),
              ]
            ),
            _c(
              "BaseFilter",
              {
                attrs: { isActive: _vm.isActive, width: 466 },
                on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
              },
              [
                _c(
                  "div",
                  { staticClass: "filter" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "form",
                        attrs: { model: _vm.filterList, "label-width": "68px" },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.active ? "创建日期" : "ETA" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "320px" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "至",
                                align: "center",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd",
                                "unlink-panels": "",
                                "picker-options": _vm.pickerOptions,
                              },
                              model: {
                                value: _vm.filterList.date,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterList, "date", $$v)
                                },
                                expression: "filterList.date",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.active === 0
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "审核日期" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "320px" },
                                  attrs: {
                                    type: "daterange",
                                    "range-separator": "至",
                                    align: "center",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "value-format": "yyyy-MM-dd",
                                    "unlink-panels": "",
                                    "picker-options": _vm.pickerOptions,
                                  },
                                  model: {
                                    value: _vm.filterList.reviewDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterList,
                                        "reviewDate",
                                        $$v
                                      )
                                    },
                                    expression: "filterList.reviewDate",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          { attrs: { label: "客户" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  filterable: "",
                                  placeholder: "请选择客户",
                                },
                                model: {
                                  value: _vm.filterList.companyId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterList, "companyId", $$v)
                                  },
                                  expression: "filterList.companyId",
                                },
                              },
                              _vm._l(_vm.companyOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.active === 0
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "关账" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "320px" },
                                    attrs: {
                                      filterable: "",
                                      placeholder: "请选择是否关联",
                                    },
                                    model: {
                                      value: _vm.filterList.closeType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filterList,
                                          "closeType",
                                          $$v
                                        )
                                      },
                                      expression: "filterList.closeType",
                                    },
                                  },
                                  _vm._l(_vm.closeTypeOptions, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.active === 1
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "关账" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "320px" },
                                    attrs: {
                                      filterable: "",
                                      placeholder: "请选择是否关联",
                                    },
                                    model: {
                                      value:
                                        _vm.filterList.closingAccountStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filterList,
                                          "closingAccountStatus",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "filterList.closingAccountStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.closeTypeOptions1,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          { attrs: { label: "关账号码" } },
                          [
                            _c("base-muti-input", {
                              ref: "baseMutiInput1",
                              staticStyle: { width: "320px" },
                              model: {
                                value: _vm.filterList.closeNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterList, "closeNo", $$v)
                                },
                                expression: "filterList.closeNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                key: _vm.active,
                attrs: {
                  height: _vm.height,
                  tableData: {
                    ..._vm.tableData,
                    fileds: _vm.fileds,
                  },
                  loading: _vm.loading,
                  pageIndex: _vm.pagerConfig.pageIndex,
                  pageSize: _vm.pagerConfig.pageSize,
                  isEmptyBorder: true,
                },
                on: {
                  handleSelectionChange: _vm.handleSelectionChange,
                  handlePageChange: _vm.handlePageChange,
                  sortChange: _vm.sortChange,
                  dblclick: _vm.showBillingDetail,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c("div", { staticClass: "table-opt" }, [
                                _c(
                                  "div",
                                  [
                                    _vm.active === 0
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permissson",
                                                rawName: "v-permissson",
                                                value: "detail",
                                                expression: "'detail'",
                                              },
                                            ],
                                            staticClass: "opt-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showBillingDetail(
                                                  row.scope
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("明细")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                              _c("img", {
                                staticStyle: { "margin-left": "-14px" },
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "closeType",
                      fn: function (row) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "tips",
                              style: _vm.formatterColor(row.scope.closeType),
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatter")(row.scope.closeType)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "closingAccountStatus",
                      fn: function (row) {
                        return [
                          _c(
                            "span",
                            {
                              class: [
                                "tips",
                                `closingAccountStatus${row.scope.closingAccountStatus}`,
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    !row.scope.closingAccountStatus
                                      ? "未关账"
                                      : "已关账"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "grossProfit",
                      fn: function (row) {
                        return [
                          _c(
                            "span",
                            {
                              style: {
                                color:
                                  row.scope.grossProfit > 0 ? "" : "#fe453d",
                              },
                            },
                            [_vm._v(" " + _vm._s(row.scope.grossProfit) + " ")]
                          ),
                        ]
                      },
                    },
                    {
                      key: "totalPayable",
                      fn: function (row) {
                        return [
                          _c("span", [
                            _vm._v(" " + _vm._s(row.scope.totalPayable) + " "),
                            _c("img", {
                              staticClass: "icon",
                              attrs: {
                                src: require("@/assets/images/order/cut.png"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.psDetail(row.scope)
                                },
                              },
                            }),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "otherServiceType",
                      fn: function (row) {
                        return _c("div", { staticClass: "otherServiceType" }, [
                          _c("div", { staticClass: "type-item flex_c_c" }, [
                            _vm._v(
                              " " + _vm._s(row.scope.otherServiceTypes) + " "
                            ),
                          ]),
                        ])
                      },
                    },
                    {
                      key: "custom-total",
                      fn: function () {
                        return [
                          _vm.active === 0
                            ? _c("div", { staticClass: "custom-total" }, [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c("div", { staticClass: "total" }, [
                                      _vm._v(" 应付总计："),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.total.totalPayableAmount) +
                                            " USD"
                                        ),
                                      ]),
                                      _vm._v("   应付关税总计："),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.total.totalPayableTariffAmount
                                          ) + " USD"
                                        ),
                                      ]),
                                      _vm._v("   应收总计："),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.total.totalReceivableAmount
                                          ) + " USD"
                                        ),
                                      ]),
                                      _vm._v("   应收关税总计："),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.total
                                              .totalReceivableTariffAmount
                                          ) + " USD"
                                        ),
                                      ]),
                                      _vm._v("   毛利总计："),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.total.totalGrossProfitAmount
                                          ) + " USD"
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3799386465
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("GrossProfitQTDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible,
          containerNumber: _vm.rowData.containerNumber,
          filter: {
            startDate:
              _vm.filterList.date && _vm.filterList.date.length > 0
                ? _vm.filterList.date[0]
                : "",
            endDate:
              _vm.filterList.date && _vm.filterList.date.length > 0
                ? _vm.filterList.date[1]
                : "",
            id: _vm.rowData.mblId,
          },
        },
        on: {
          ok: function ($event) {
            _vm.dialogVisible = false
          },
        },
      }),
      _c("CloseBillDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2, active: _vm.active },
        on: {
          ok: function ($event) {
            _vm.dialogVisible2 = false
            _vm.initList()
          },
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
        },
      }),
      _c("GrossProfitPSDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible3,
          filter: {
            startDate:
              _vm.filterList.date && _vm.filterList.date.length > 0
                ? _vm.filterList.date[0]
                : "",
            endDate:
              _vm.filterList.date && _vm.filterList.date.length > 0
                ? _vm.filterList.date[1]
                : "",
            id: _vm.rowData.orderId,
          },
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible3 = false
          },
        },
      }),
      _c("GrossProfitFileDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible4,
          filter: {
            ..._vm.formatterFilter(),
            needPaged: false,
          },
          type: _vm.active,
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible4 = false
          },
        },
      }),
      _c("CheckoutDialog", {
        attrs: { dialogVisible: _vm.dialogVisible5 },
        on: {
          ok: function ($event) {
            _vm.dialogVisible5 = false
          },
          cancel: function ($event) {
            _vm.dialogVisible5 = false
          },
        },
      }),
      _c("OtherBusDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible6,
          active: _vm.active,
          otherServiceId: _vm.rowData.id,
        },
        on: {
          ok: function ($event) {
            _vm.dialogVisible6 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }